import type { Environment } from '@change-corgi/config/environments';

import __mediaAssets from '../config/mediaAssets.json';

const mediaAssetBasePath = __mediaAssets.basePaths as Readonly<Record<Exclude<Environment, 'development'>, string>>;

export function getMediaAssetsBasePath(environment: Exclude<Environment, 'development'>): string {
	return mediaAssetBasePath[environment];
}
